module.exports = __webpack_public_path__ + "img/image-baner2.3883ba78.png";